export const UNGHOST_REMINDER = "Removing ghost mode does not restore cancelled reminders. Re-arm them manually.";

export function GhostMark({ ghosted }: { ghosted?: boolean }) {
  if (!ghosted) return null;
  return (
    <span
      data-testid="ghost-mark"
      className="ml-1 inline-flex items-center rounded bg-slate-200 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-700"
    >
      Ghost
    </span>
  );
}
